module.exports = __webpack_public_path__ + "static/img/canary2_tr.4543a8d7.png";